// removed by extract-text-webpack-plugin
module.exports = {"fullScreenPropertyCell":"me85y1cYCtq4_WLuwe1Hr","addPrivatComment":"PShq2HGwvI7NLB1mEH2hH","isPromoted":"z-BVul-9MbTIWOqUvyJWN","fullScreenPropertyCellInfo":"IyGoj9f1p0uQ4oLCXCimO","topLine":"_1v6pkWaNfAJTsZNNg9ypFa","bottomLine":"_2LIs5LdY5lgWhj_so72gyy","rightColumn":"_2hdQ27CYJgJAPxEnn3L0RG","infoBlock":"cp8tlj69iq6OLQ_4LT_mB","fullScreenPropertyImage":"_1Vc14QFJZmI8IgVwfwHLDA","moreDetailsButton":"_3ayiPaFJ4JBv2N_gSGZ2_p","date":"_391eiJlj7QLkgjRTSG-9XH","favoriteIcon":"IybV30VLphBg-kMMumXNe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FullScreenPropertyCell/FullScreenPropertyCell.scss
// module id = 1598
// module chunks = 0